<template>
  <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
      <v-date-picker
        :masks="
          masks
            ? masks
            : {
                input: 'DD/MM/YYYY',
                data: ['DD/MM/YYYY'],
              }
        "
        :max-date="maxDate"
        :min-date="minDate"
        :mode="mode"
        class="col-12 px-0 inline-block h-full"
        v-model="item"
        v-on:input="$emit('input', item)"
        :is-required="required"
        locale="pt-BR"
        :timezone="'America/Sao_Paulo'"
        :model-config="modelConfig"
        is24hr
        ref="inputCalendar"
      >
        <template v-slot="{ inputValue, togglePopover, inputEvents }"
          ><div class="input-group">
            <div class="input-group-prepend">
              <button
                class="btn px-2 btn-sm btn-light border"
                type="button"
                @click="
                  $emit('submit');
                  togglePopover();
                "
                :disabled="disabled"
              >
                <i
                  class="mdi mdi-18px"
                  :class="
                    mode == 'time'
                      ? 'mdi-clock-time-three-outline'
                      : 'mdi-calendar-blank'
                  "
                ></i>
              </button>
            </div>
            <input
              class="form-control calendar"
              v-bind:value="inputValue"
              v-on="inputEvents"
              :placeholder="placeholder ? placeholder : label"
              :disabled="disabled"
              @click="togglePopover()"
              :required="required"
            />
          </div>
        </template>
      </v-date-picker>
    </div>
  </div>
</template>
<script>
/*Mode
    - dateTime
    - time
*/
export default {
  props: [
    "maxDate",
    "minDate",
    "type",
    "value",
    "label",
    "required",
    "grid",
    "readonly",
    "disabled",
    "placeholder",
    "mt",
    "iconBtn",
    "btnText",
    "masks",
    "mode",
  ],
  data() {
    return {
      item: null,
      modelConfig: {
        type: "string",
        mask: this.mode == "time" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD", // Uses 'iso' if missing
      },
    };
  },
  beforeMount() {
    this.item = this.value;
  },
  watch: {
    value(n, o) {
      this.item = n;
    },
  },
};
</script>
<style lang="css">
input.form-control.calendar {
  background-color: #ffffff !important;
}
.input-group .btn {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.border-secondary {
  border: 1px solid #e9eaec !important;
}
.btn-light,
.btn-light:focus {
  color: #333333;
  background-color: #ffffff !important;
  border: 1px solid #e4e5e7 !important;
  border-right: 0 !important;
}
.vc-date-time .vc-date {
  display: none !important;
}
input.form-control.calendar:disabled {
  background: #f4f4f5 !important;
}
</style>
